import { useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Meteors } from '@stianlarsen/meteors'
import blogs from '../../content/blogs/registry'
import './BlogList.css'

const BlogList = () => {
  const [search, setSearch] = useState('')
  const [activeTag, setActiveTag] = useState('All')

  const allTags = useMemo(() => {
    const tagSet = new Set()
    blogs.forEach((b) => b.tags.forEach((t) => tagSet.add(t)))
    return ['All', ...Array.from(tagSet)]
  }, [])

  const filtered = useMemo(() => {
    return blogs.filter((blog) => {
      const matchesTag =
        activeTag === 'All' || blog.tags.includes(activeTag)
      const matchesSearch =
        !search ||
        blog.title.toLowerCase().includes(search.toLowerCase()) ||
        blog.description.toLowerCase().includes(search.toLowerCase()) ||
        blog.tags.some((t) =>
          t.toLowerCase().includes(search.toLowerCase())
        )
      return matchesTag && matchesSearch
    })
  }, [search, activeTag])

  return (
    <div className="blog-list">
      <div className="blog-list__container" style={{ position: 'relative' }}>
        <Meteors
          speed={0.1}
          size={20}
          amount={2}
          colorLightmode="#2978b5"
          colorDarkmode="white"
          fallingSide="left"
        />
        <h2 className="blog-list__title">Blogs</h2>

        <div className="blog-list__controls">
          <input
            type="text"
            placeholder="Search blogs..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="blog-list__search"
          />
          <select
            value={activeTag}
            onChange={(e) => setActiveTag(e.target.value)}
            className="blog-list__select"
          >
            {allTags.map((tag) => (
              <option key={tag} value={tag}>
                {tag}
              </option>
            ))}
          </select>
        </div>

        <div className="blog-list__grid">
        {filtered.length === 0 && (
          <p className="blog-list__empty">No blogs found.</p>
        )}

        {filtered.map((blog) => (
          <Link
            to={`/blogs/${blog.slug}`}
            key={blog.slug}
            className="blog-list__card"
          >
            <div className="blog-list__card-img-wrap">
              <img
                src={blog.thumbnail}
                alt={blog.title}
                className="blog-list__card-img"
              />
            </div>
            <div className="blog-list__card-body">
              <div className="blog-list__card-tags">
                {blog.tags.slice(0, 3).map((tag) => (
                  <span key={tag} className="blog-list__card-tag">
                    {tag}
                  </span>
                ))}
              </div>
              <h2 className="blog-list__card-title">{blog.title}</h2>
              <p className="blog-list__card-desc">{blog.description}</p>
              <div className="blog-list__card-meta">
                <span>
                  {new Date(blog.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                  })}
                </span>
                <span className="blog-list__card-dot">·</span>
                <span>{blog.readTime}</span>
              </div>
            </div>
          </Link>
        ))}
        </div>

        <div className="blog-list__back">
          <Link to="/" className="blog-list__back-link">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  )
}

export default BlogList
